import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  // Signal to control full-page loader visibility
  private fullPageLoading = signal<boolean>(false);

  loadingText = signal('');

  // Signal to control section loader visibility
  isSectionLoading = signal<Record<string, boolean>>({}); // Changed to Record

  // Show full-page loader
  showFullPageLoader(loadingMessage = '') {
    this.loadingText.set(loadingMessage);
    this.fullPageLoading.set(true);
  }

  // Hide full-page loader
  hideFullPageLoader(): void {
    this.fullPageLoading.set(false);
  }

  isFullPageLoading(): boolean {
    return this.fullPageLoading();
  }

  // Show loader for a specific section
  showSectionLoader(sectionId: string): void {
    this.isSectionLoading.update((loadingStates) => {
      loadingStates[sectionId] = true;
      return loadingStates;
    });
  }

  // Hide loader for a specific section
  hideSectionLoader(sectionId: string): void {
    this.isSectionLoading.update((loadingStates) => {
      loadingStates[sectionId] = false;
      return loadingStates;
    });
  }
}
